import React from "react";
import { GridColDef } from "@mui/x-data-grid-premium";
import { Chip, Stack, TableContainer } from "@mui/material";
import DataGridTable from "../../base/DataGridTable";
import { useSelector } from "../../../store";
import TableActions from "../../base/TableActions";
import checkRole, { UserRoles } from "../../../helpers/checkRole";

interface Props {
  handleEdit?: (user: number) => void;
  handleAdminRoute?: (id: number) => void;
}

const UsersTable: React.FC<Props> = (props) => {
  const { handleEdit, handleAdminRoute } = props;

  const { userList, status } = useSelector((store) => store.users);

  const rows =
    userList &&
    userList
      .filter((x) => checkRole(x, UserRoles.AnyDetector))
      .map((user, index) => {
        let rowObject = {
          id: user.id || index,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          role: user.roles
            ?.filter(
              (x) =>
                x.id === UserRoles.GlobalAdmin ||
                x.id === UserRoles.DetectorAdmin ||
                x.id === UserRoles.DetectorUser
            )
            .map((r) => (
              <Chip
                key={r.id}
                label={r.value?.toString()}
                size="small"
                sx={{ m: 0.25 }}
                color="info"
              />
            )),
          dashboard: !!user.dashboard
            ? `${user.dashboard?.value} (${user.dashboard?.id})`
            : "",
          actions: (
            <TableActions
              id={user.id!}
              handleEdit={() => handleEdit!(user.id!)}
              handleAdminRoute={() => handleAdminRoute!(user.id!)}
            />
          ),
        };

        return rowObject;
      });

  const columns: GridColDef[] = [
    {
      field: "firstName",
      headerName: "First Name",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "lastName",
      headerName: "Last Name",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "email",
      headerName: "Email",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "role",
      headerName: "Roles",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
      renderCell: (params) => (
        <Stack
          direction="row"
          flexWrap="wrap"
          height="100%"
          justifyContent="center"
          alignContent="center"
        >
          {params.value}
        </Stack>
      ),
    },
    {
      field: "dashboard",
      headerName: "Home Dashboard",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      disableExport: true,
      renderCell: (params) => <>{params.value}</>,
      headerClassName: "header",
    },
  ];

  return (
    <TableContainer>
      <DataGridTable
        columns={columns}
        rows={rows || []}
        loading={status === "loading"}
      />
    </TableContainer>
  );
};

export default UsersTable;
